import Repository from '@/repositories/marketing'
const resource = '/landing_pages'

export default {
    fetch(config){
        return Repository.get(`${resource}.json`,config)
    },
    create(config){
        return Repository.post(`${resource}.json`,config)
    },
    put(id,config){
        return Repository.put(`${resource}/${id}.json`,config)
    },
    fetchById(id,config){
        return Repository.get(`${resource}/${id}.json`,config)
    },
    delete(config){
        return Repository.delete(`landing_pages/bulk_delete.json`,config)
    },
    fetchTemplate(){
        return Repository.get(`${resource}/templates.json`)
    },
    validateName(config){
        return Repository.get(`${resource}/validate_name.json`,config)
    },
    validateUrl(config){
        return Repository.get(`${resource}/validate_url.json`,config)
    },
    getTemplateList(config){
        return Repository.get(`${resource}/templates.json`,config)
    },
    getLibraryList(config){
        return Repository.get(`${resource}/show_library_templates.json`,config)
    },
    getCnameUrl(config){
        return Repository.get(`${resource}/get_cname_value.json`,config)
    },
    show(id, config){
        return Repository.get(`${resource}/${id}.json`,config)
    }
}
